import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { NumericInput } from '@dnhb/numeric-input';
import { InputContainer, Errors } from './';
import PercentageSvg from 'images/shared/percent.svg';

const Input = styled(NumericInput)`
  padding-right: 30px !important;  
`;

const iconSize = '12px'
const Postfix = styled('div')`
  position: absolute;
  top: 0;
  right: 0;
  height: 40px;
  
  padding: 0 10px 0 8px;

  pointer-events: none;

  display: flex;
  align-items: center;

  svg {
    display: block;
    height: ${iconSize};
    width: ${iconSize};
    fill: ${props => {
      if (props.disabled) return props.theme.disabledFontColor;
      if (props.errors) return props.theme.errorColor;
      return props.theme.primaryColor;
    }};
  }
`;

const PercentInput = ({ errors,onChange, onBlur, onFocus, onClick, ...props }) => (
  <InputContainer errors={errors} disabled={props.disabled} maxWidth="31%" >
    <Input
      {...props}
      value={props.disabled ? null : Number(props.value)}
      placeholder={props.disabled ? '' : props.placeholder}
      onChange={onChange}
      onBlur={onBlur}
      onFocus={onFocus}
      onClick={onClick}
      maxWidth="31%"
    />
    <Postfix errors={errors} disabled={props.disabled} value={props.value}>
      <PercentageSvg />
    </Postfix>
    <Errors errors={errors} />
  </InputContainer>
);

PercentInput.propTypes = {
  id: PropTypes.string,
  placeholder: PropTypes.string,
  name: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  onClick: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  errors: PropTypes.oneOfType([PropTypes.array, PropTypes.bool]),
  alwaysDecimals: PropTypes.bool,
  decimals: PropTypes.number,
};

PercentInput.defaultProps = {
  id: null,
  placeholder: '',
  name: null,
  disabled: false,
  onChange: () => {},
  onBlur: () => {},
  onFocus: () => {},
  onClick: () => {},
  value: null,
  errors: null,
  alwaysDecimals: true,
  decimals: 2,
};

export default PercentInput;
